"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@requestnetwork/types");
const address_based_1 = require("../address-based");
const CURRENT_VERSION = '0.1.0';
/**
 * Implementation of the payment network to pay in ERC20 tokens based on an Ethereum address
 * With this extension one request can have two dedicated Ethereum addresses (one for payment and one for refund)
 * Every ERC20 ethereum transaction, using the request currency ERC20, that reaches these addresses will be interpreted as payment or refund.
 * Important: the addresses must be exclusive to the request
 */
class Erc20AddressBasedPaymentNetwork extends address_based_1.default {
    constructor(currencyManager) {
        super(currencyManager, types_1.ExtensionTypes.PAYMENT_NETWORK_ID.ERC20_ADDRESS_BASED, CURRENT_VERSION, types_1.RequestLogicTypes.CURRENCY.ERC20);
    }
}
exports.default = Erc20AddressBasedPaymentNetwork;
